import SelectionPanel from './SelectionPanel';

export default SelectionPanel;
